import { FloatingFormItem } from '@/components/_common';
import { useWorkOrderItemRefusePublic } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.hooks';
import { WorkOrderItemRefusePublicRequest } from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { Form, Modal, ModalProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

interface FormValues {
  itemRejectedReason?: string;
}

interface Props extends Omit<ModalProps, 'onCancel'> {
  data?: WorkOrderItemRefusePublicRequest;
  onCancel?: () => void;
}

export default function ItemRefusePublicModal(props: Props) {
  const [form] = Form.useForm<FormValues>();

  const workOrderItemRefuse = useWorkOrderItemRefusePublic();

  const handleCancel = () => {
    form.resetFields();
    props.onCancel?.();
  };

  const handleOk = async () => {
    const values = await form.validateFields();

    if (!!props.data) {
      await workOrderItemRefuse.mutateAsync({
        complementId: props.data.complementId,
        workOrderItemId: props.data.workOrderItemId,
        isItemRejectedByCustomer: true,
        itemRejectedReason: values.itemRejectedReason,
      });

      handleCancel();
    }
  };

  return (
    <Modal
      {...props}
      title="Recusar Item"
      okType="danger"
      okText="Recusar"
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={workOrderItemRefuse.isLoading}
    >
      <Form form={form}>
        <FloatingFormItem name="itemRejectedReason" label="Motivo da Recusa">
          <TextArea autoSize={{ minRows: 4, maxRows: 8 }} />
        </FloatingFormItem>
      </Form>
    </Modal>
  );
}
